import React, { Component } from 'react';

import { Image } from 'react-bootstrap';

class GalleryImage extends Component {
    
    constructor(props) {
      super(props);
      this.state = {hovered: false};
    }
  
    render() {
      return (
            <Image
                src={ this.props.src }
                alt={ this.props.title }
                onClick={() => this.props.onClickHandler(this.props.index)}
                onMouseOver={() => this.setState({hovered: true})}
                onMouseOut={() => this.setState({hovered: false})}
                style={{ transform: `${this.state.hovered ? 'scale(1.1,1.1)' : 'scale(1,1)'}`, transition: `${this.state.hovered ? '0.4s' : '0.4s'}`}}
                fluid
            />
      );
    }
}

export default GalleryImage;
